import { render } from "./leftPie.vue?vue&type=template&id=a19c964a"
import script from "./leftPie.vue?vue&type=script&lang=js"
export * from "./leftPie.vue?vue&type=script&lang=js"
script.render = render

export default script